import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import AlLogisticPricingRequests from 'app/requests/AirlineLogisticPricing.requests'
import AlLogisticPricingForm from '../AlLogisticPricingForm'

const AlLogisticPricingCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <AlLogisticPricingForm
            onSuccess={onSuccess}
            requestParam={AlLogisticPricingRequests.create()}
        />
    )
}

export default AlLogisticPricingCreate
